import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import Typography from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Typography';

const styles = theme => ({
  root: {
    padding: theme.spacing(2, 0),
  },
  text: {
    fontSize: '1rem',
  },
});

const WelcomeParagraphs = ({
  className,
  classes,
  paragraphs,
  variant,
}) => {
  return (
    <Box
      className={classNames(classes.root, className)}
    >
      {paragraphs.map(({ text }, i) => {
        return (
          <Typography
            className={classes.text}
            key={i} // eslint-disable-line react/no-array-index-key
            weight={'medium'}
            color={'primaryGray'}
            variant={variant}
            paragraph
          >
            {text}
          </Typography>
        );
      })}
    </Box>
  );
};

WelcomeParagraphs.defaultProps = {
  className: '',
  variant: undefined,
};

WelcomeParagraphs.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  paragraphs: PropTypes.arrayOf(PropTypes.object).isRequired,
  variant: PropTypes.string,
};

const StyledWelcomeParagraphs = withStyles(styles)(WelcomeParagraphs);
export default StyledWelcomeParagraphs;

export const MetaWelcomeParagraphs = ({ value }) => {
  return <StyledWelcomeParagraphs paragraphs={[{ text: value }]} />;
};

MetaWelcomeParagraphs.propTypes = {
  value: PropTypes.string.isRequired,
};
